import { useModal } from '@ampol/design-system';
import { ButtonColor } from '@ampol/design-system/lib';
import { switchExpiryDate } from 'utilities/card-utilities';
import AddEditCardImage from '../add-edit-card-image/add-edit-card-image';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone.js';
import utc from 'dayjs/plugin/utc';
import { useSelectCardFormValues, useSelectPlasticType } from 'selectors/selectors';
dayjs.extend(utc);
dayjs.extend(timezone);

export default function useCardImageModal() {
  const formValues = useSelectCardFormValues();
  const plasticType = useSelectPlasticType();
  const issueDate = dayjs().add(60, 'month').tz('Australia/Sydney').format('MM/YY');

  const getCardDetails = (values) => {
    return {
      embossingLine2: values?.embossedCompanyName ?? '',
      embossingName: values?.embossedLastName ?? '',
      regoNumber: values?.registrationNumber ?? '',
      expiryDate: values?.expiryDate
        ? values?.expiryDate?.length === 4
          ? switchExpiryDate(values?.expiryDate)
          : values?.expiryDate
        : issueDate,
    };
  };

  const cardImageModal = useModal({
    id: 'card-image-details',
    title: 'Card Details',
    variant: 'dynamic',
    color: ButtonColor.Blue,
    content: <AddEditCardImage plasticType={plasticType} {...getCardDetails(formValues)} />,
    actions: [
      {
        label: 'Back',
        onClick: () => cardImageModal.close(),
      },
    ],
  });
  return cardImageModal;
}
